import { SkeletonLoading } from "react-migration/components/SkeletonLoading";

export const LineLoading = () => (
  <div className="relative h-[20px] w-full">
    <SkeletonLoading rows={1} cols={1} showPadding={false} />
  </div>
);
